module.exports = __webpack_public_path__ + "static/palm-ae02c62adb3c6214bcdaad040241e87f.svg";